module.exports = __webpack_public_path__ + "media/images/icon-facebook-84b42a14db7d5dfcf07e06ab744ef6b2.svg";